import React, {useEffect, useRef} from 'react';
import {Field} from 'react-final-form';
import {usePage} from "@inertiajs/inertia-react";
import RadioButton from './RadioBig';
import Grid from "@material-ui/core/Grid";
import TextInput from "./TextInput";
import {Trans} from "../utils/i18n";
import {useFormState} from "../FormComponents/FormState";
import classNames from "classnames";
import {trackConversion} from "../utils/analytics";
import {useTranslation} from 'react-i18next';

const ProblemSelectBig = React.memo(function ({
                                                  values,
                                                  hideProblemInput,
                                                  addCoverageId,
                                                  setAddressId,
                                                  form,
                                                  warningClassName,
                                                  hideEducationText = false
                                              }) {
        const {t} = useTranslation();

        const orderEntryState = useFormState();
        const {product,} = values;
        const selectedProduct = orderEntryState && orderEntryState.products && orderEntryState.products.find(item => String(item.id) === product)
            || orderEntryState?.serialNumber?.product
            || orderEntryState?.selectedCategory;

        const problems = selectedProduct && (selectedProduct?.problems?.filter(item => item.type === 'problem' || item.type === 'doa'));
        const initialValue = useRef(values.problem_1);
        const currentProblem = selectedProduct && selectedProduct.problems && selectedProduct.problems.find(item => parseInt(values.problem_1) === item.id);
        const currentProblem2 = currentProblem && currentProblem.problems?.find(item => parseInt(values.problem_2) === item.id);
        const {client,} = usePage().props;


        useEffect(() => {
            if (values.problem_1 !== initialValue.current) {
                form.change('problem_2', '');
                initialValue.current = values.problem_1;
            }
        }, [values.problem_1]);

        useEffect(() => {
            if (values.problem_2) {
                trackConversion({
                    action: 'OrderEntryClickProblem2:' + (values.problem_2),
                    resourceId: values.problem_2,
                    resourceType: 'App\\Models\\Problem'
                });
            }
        }, [values.problem_2]);

        useEffect(() => {
            if (values.problem_1) {
                trackConversion({
                    action: 'OrderEntryClickProblem1',
                    resourceId: values.problem_1,
                    resourceType: 'App\\Models\\Problem'
                });
            }
        }, [values.problem_1]);

        if (!selectedProduct || !selectedProduct.problems) {
            return <div></div>;
        }

        return (
            <div>
                <div>
                    <Grid container spacing={3}>
                        {
                            problems
                                .map((problem) =>
                                    <Grid item xs={12} sm={4} key={problem.id}>
                                        <Field
                                            name={'problem_1'}
                                            type={'radio'}
                                            value={problem.id.toString()}
                                            component={RadioButton}
                                            validate={problem => (problem ? undefined :
                                                <Trans i18nKey="formField.required">Required</Trans>)}
                                            field={{
                                                label: t(problem.name),
                                                titel: t(problem.name),
                                                description: problem.description,
                                                price: problem.price,
                                                image: problem.image,
                                            }}
                                        />
                                    </Grid>,
                                )
                        }
                    </Grid>
                    {
                        currentProblem && !currentProblem.education_text &&
                        <>
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={8}>
                                    <h3>
                                        <Trans i18nKey="orderEntry.problemDetails">Detailed Problem</Trans>
                                    </h3>
                                </Grid>
                            </Grid>
                            <Grid container spacing={3}>
                                {
                                    currentProblem && currentProblem.problems
                                        .map((problem) =>
                                            <Grid item xs={12} sm={6} key={problem.id}>
                                                <Field
                                                    name={'problem_2'}
                                                    type={'radio'}
                                                    value={problem.id.toString()}
                                                    //placeholder={field.placeholder}
                                                    component={RadioButton}
                                                    validate={problem => (problem ? undefined :
                                                        <Trans i18nKey="formField.required">Required</Trans>)}
                                                    field={{
                                                        label: problem.name,
                                                        titel: problem.name,
                                                        description: problem.description,
                                                        price: problem.price,
                                                        image: problem.image,
                                                    }}
                                                />
                                            </Grid>,
                                        )
                                }
                            </Grid>
                        </>
                    }
                    {
                        !!(currentProblem?.education_text || currentProblem2?.education_text) && !hideEducationText &&
                        <div className={'flex justify-center items-center w-full mt-6'}>
                            <div className={classNames("py-6 px-9 rounded-2xl shadow-lg min-w-lg text-center", {
                                'bg-red-100': !warningClassName,
                            }, warningClassName)}>
                                <h3 className={'h3 text-center'}>
                                    {
                                        (currentProblem?.education_text || currentProblem2?.education_text)
                                    }
                                </h3>
                                {
                                    client.key === 'amazon' &&
                                    <a className={'underline text-black mt-1.5 text-sm'}
                                       href={'https://www.amazon.co.uk/gp/help/customer/display.html'} target={'_blank'}>
                                        https://www.amazon.co.uk/gp/help/customer/display.html
                                    </a>
                                }
                            </div>
                        </div>
                    }
                    {
                        !hideProblemInput && !(currentProblem?.education_text || currentProblem2?.education_text) && !!currentProblem2 &&
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={12}>
                                <div className={'mt-6'}>
                                    <Field
                                        name={'problem_description'}
                                        type={'text'}
                                        component={TextInput}
                                        field={{
                                            label: <Trans i18nKey="serialNumber.problemDescription">Problem
                                                description</Trans>,
                                            multiline: true,
                                        }}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    }
                </div>
            </div>
        );
    },
    function areEqual(prevProps, nextProps) {
        return JSON.stringify(prevProps) === JSON.stringify(nextProps);
    });

export default ProblemSelectBig;
